/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
console.log("packs/application.js start")

import "core-js/stable";
import "regenerator-runtime/runtime";

require("jquery");
require("jquery-validation");
require("bootstrap");
window.moment = require("moment");

require("tempusdominus-bootstrap-4");
import "tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css";
import DP_FLASH from "./Flash";
global.DP_FLASH = DP_FLASH;

import "css/external.scss";

// Support component names relative to this directory:

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Add authenticity token to all ajax requests
$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});

let DataPulse = {};

function fadeOutAnimation() {
  $(".main-content").css("opacity", 0);
  cancelAnimation();
  DataPulse.transitionLoader = setTimeout(() => {
    positionSpinner();
    $(".loading-spinner-container").css({ opacity: "1", display: "block" });
  }, 5);
}

function fadeInAnimation() {
  $(".loading-spinner-container").css({ opacity: "0", display: "none" });
  cancelAnimation();
  DataPulse.transitionLoader = setTimeout(() => {
    positionSpinner();
    $(".main-content").css("opacity", 1);    
  }, 5);
}

function cancelAnimation() {
  if (DataPulse.transitionLoader) {
    clearTimeout(DataPulse.transitionLoader);
  }
}

function positionSpinner() {
  if ($('.right-side')[0]) {
    let topPos = ($('.right-side').height() / 2) - 80;
    let leftPos = ($('.right-side').width() / 2) + ($('.right-side').offset().left - 250);
    $('.loading-spinner-container').css({ top: topPos, left: leftPos });
  }
}

let resizeObserver = new ResizeObserver(() => {
  positionSpinner();
});

if ($('.right-side')[0]) {
  resizeObserver.observe($('.right-side')[0]);
}

$(document).on("turbolinks:request-start", () => {
  fadeOutAnimation();
});
$(document).on("turbolinks:load", () => {
  fadeInAnimation();
});

console.log("packs/application.js end")

